export const testimonialsDetails = [
  {
    id: 1,
    quote:
      "My hair fall reduced noticeably within a month. The shampoo lathers well and doesn't dry out my scalp.",
    name: "Priya S.",
    location: "Pune",
  },
  {
    id: 2,
    quote:
      "Finally a shampoo the whole family can use. Light fragrance, no irritation, great value.",
    name: "Anand K.",
    location: "Chennai",
  },
  {
    id: 3,
    quote:
      "The rosemary vitalizer is my favourite. My roots feel stronger and hair looks fuller.",
    name: "Meera R.",
    location: "Jaipur",
  },
];
